'use client';

import { getHtmlThemeAttributes } from '@actr/style/src/themes';

import NextErrorBoundary, { type NextErrorBoundaryProps } from '@/components/common/next-error-boundary';
import config from '@/configs';

const GlobalErrorPage = (props: NextErrorBoundaryProps) => (
  <html lang="ru" {...getHtmlThemeAttributes(config.theme)}>
    <body>
      <NextErrorBoundary {...props} />
    </body>
  </html>
);

export default GlobalErrorPage;
